import { useState } from 'react'
import { api, ErreurApi } from '../api'

/**
 * Entrée.
 *
 * Le ton du monde s'applique à l'interface : on constate, on ne souhaite pas la
 * bienvenue, on ne félicite pas.
 */
export function Authentification({ surEntree }: { surEntree: () => void }) {
  const [nouveau, setNouveau] = useState(false)
  const [email, setEmail] = useState('')
  const [motDePasse, setMotDePasse] = useState('')
  const [erreur, setErreur] = useState<string | null>(null)
  const [enCours, setEnCours] = useState(false)

  async function soumettre(evenement: React.FormEvent) {
    evenement.preventDefault()
    setErreur(null)
    setEnCours(true)
    try {
      if (nouveau) await api.inscription(email, motDePasse)
      else await api.connexion(email, motDePasse)
      surEntree()
    } catch (e) {
      setErreur(e instanceof ErreurApi ? e.message : "Quelque chose n'a pas abouti.")
    } finally {
      setEnCours(false)
    }
  }

  return (
    <div className="cadre">
      <div className="entete">
        <div className="surtitre">Les dieux anciens n'ont rien bâti</div>
        <h1>WHAT REMAINS</h1>
        <p className="attenue" style={{ maxWidth: '46ch' }}>
          Ils ont ôté, jusqu'à ce que ne demeure que le nécessaire. Ce qui demeure, on l'appelle
          le monde.
        </p>
      </div>

      <section>
        <div className="surtitre">{nouveau ? 'Ouvrir un compte' : 'Reprendre'}</div>
        <form onSubmit={soumettre}>
          {/*
            Un identifiant, pas une adresse.

            Le champ était en `type="email"`, donc c'était le NAVIGATEUR qui
            refusait tout ce qui n'a pas d'arobase, avant même que le serveur en
            entende parler. Or le jeu n'envoie aucun courriel et n'a aucun canal
            pour le faire : exiger la forme d'une adresse était une cérémonie
            dont le seul effet était d'interdire d'écrire son nom.
          */}
          <label>
            <span className="etiquette">Identifiant</span>
            <input
              type="text"
              value={email}
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {nouveau && (
              <span className="tenu" style={{ fontSize: 12 }}>
                Ce que tu veux, trois caractères au moins. Un nom fait l’affaire.
              </span>
            )}
          </label>
          <label>
            <span className="etiquette">Mot de passe</span>
            <input
              type="password"
              value={motDePasse}
              autoComplete={nouveau ? 'new-password' : 'current-password'}
              onChange={(e) => setMotDePasse(e.target.value)}
              required
            />
            {nouveau && <span className="tenu" style={{ fontSize: 12 }}>Dix caractères au moins.</span>}
          </label>

          {erreur && <p className="erreur">{erreur}</p>}

          <button className="action" type="submit" disabled={enCours}>
            {nouveau ? 'Ouvrir' : 'Entrer'}
          </button>
        </form>

        <div style={{ marginTop: 22 }}>
          <button className="discret" onClick={() => { setNouveau(!nouveau); setErreur(null) }}>
            {nouveau ? "J'ai déjà un compte" : "Je n'en ai pas encore"}
          </button>
        </div>
      </section>
    </div>
  )
}
